"use client";
import React, { useEffect, useMemo } from "react";
import "./page.css";
import Image from "next/image";
import { useIntl } from "react-intl";
import { _eventBus } from "../../core/events/EventBus";
import { Col, Row, Typography } from "antd";
import { IUserResponse } from "../../Orchestrator/Types/Index";
import Link from "next/link";
import NeedHelpContactForm from "../../Components/NeedHelp/NeedHelpContactForm";
import { mainAppStartupFlowExecute } from "../../Flows/MainAppPage/MainAppStartFlow";
import {
  IContactCategoryConfigResponse,
  IContactFormValues,
  IContactIcon,
} from "../../Orchestrator/Types/Interface/ICustomerContact";
import { evtTree } from "../../Orchestrator/ConstantTree";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { ContactDetailsEnum } from "../../Orchestrator/Types/Enums/globalDefaultEnum";
import { contactTelHref } from "@/Lib/Utils/phoneFormat";
import { getLocalizedOpeningHour } from "../../Lib/Utils/openingHour";

const CustomerNeedHelpContact = () => {
  const [categoriesData] = useRecState<IContactCategoryConfigResponse>(
    "contactCategoriesAtom"
  );
  const intl = useIntl();
  const [userDataAtom] = useRecState<IUserResponse>("userDataAtom");
  // WhatsApp and Live Chat hidden per business request (2026-06-11).
  const contactIcons: IContactIcon[] = useMemo(
    () => [
      {
        name: intl.formatMessage({ id: "email" }),
        icon: "/assets/contact/envelope.svg",
        title: "",
        description: categoriesData.email || ContactDetailsEnum.EMAIL,
        url: `mailto:${
          categoriesData.email || ContactDetailsEnum.EMAIL
        }?subject=Need%20help`,
      },
      // {
      //   name: intl.formatMessage({ id: "whatsApp" }),
      //   icon: "/assets/contact/whats-app.svg",
      //   title: intl.formatMessage({ id: "contactAvailable" }),
      //   description: categoriesData.whatsapp || ContactDetailsEnum.WHATSAPP,
      //   url: `https://wa.me/${(
      //     categoriesData.whatsapp || ContactDetailsEnum.WHATSAPP
      //   ).replace(/\D/g, "")}`,
      // },
      // {
      //   name: intl.formatMessage({ id: "contactLiveChat" }),
      //   icon: "/assets/contact/message-text.svg",
      //   title: intl.formatMessage({ id: "contactAvailable" }),
      //   description: intl.formatMessage({ id: "chatWithAgent" }),
      //   url: "#",
      // },
      {
        name: intl.formatMessage({ id: "customerSupport" }),
        icon: "/assets/contact/phone.svg",
        title:
          getLocalizedOpeningHour(categoriesData.openingHour, intl.locale) ||
          intl.formatMessage({ id: "workingHours" }),
        description: categoriesData.phoneNumber || ContactDetailsEnum.PHONE,
        url: contactTelHref(categoriesData.phoneNumber),
      },
    ],
    [intl, categoriesData]
  );

  useEffect(() => {
    setTimeout(() => {
      mainAppStartupFlowExecute("CustomerContactFlow");
    }, 400);
    return () => {};
  }, []);

  const handleSubmit = (payload: IContactFormValues) => {
    _eventBus.emit({
      eventName: evtTree.NeedHelp.CustomerContact.Submit.Click,
      data: { data: payload },
    });
  };

  const handleBack = () => {
    _eventBus.emit({
      eventName: "ROUTE_CHANGE",
      data: "/help",
    });
  };

  const renderContactIcons = (item: IContactIcon, index: number) => {
    return (
      <Col key={index} xs={24} sm={12}>
        {/* <Link
          href={item.url || "#"}
          target={item.url?.startsWith("http") ? "_blank" : "_self"}
          className="contact-url"
        > */}
        <div className="contact-card">
          <Image src={item.icon} alt={item.name} width={54} height={54} />
          <div className="contact-card-text">
            <div>
              <Typography.Text className="contact-name">
                {item.name}
              </Typography.Text>
            </div>
            {item.title ? (
              <div>
                <Typography.Text className="contact-title">
                  {item.title}
                </Typography.Text>
              </div>
            ) : null}
            <Link
              href={item.url || "#"}
              target={item.url?.startsWith("http") ? "_blank" : "_self"}
              className="contact-url"
            >
              {item.description}
            </Link>
          </div>
        </div>
        {/* </Link> */}
      </Col>
    );
  };

  return (
    <div className="container">
    <div className="contact-main">
      {/* back */}
      <div
        className="align-items-center h-min cursor-pointer"
        onClick={handleBack}
      >
        <span className="mr-5 cursor-pointer d-flex back-btn-arrow">
          <Image
            src="/assets/booking/arrow-left.svg"
            width={14}
            height={14}
            alt="back_arrow"
          />
        </span>
        <span className="fs-16">{intl.formatMessage({ id: "backText" })}</span>
      </div>

      {/* Heading */}

      <Typography.Title level={3} className="mb-0">
        {intl.formatMessage({ id: "contactSupportHeading" })}
      </Typography.Title>

      {/* subheading */}
      <Col>
        <Typography.Title level={5} className="mb-0">
          {intl.formatMessage({ id: "helpTitle" })}
        </Typography.Title>
        <Typography.Text>
          {intl.formatMessage({ id: "getInTouch" })}
        </Typography.Text>
      </Col>
      <Row gutter={[20, 12]} className="contact-icons-row">
        {contactIcons.map(renderContactIcons)}
      </Row>

      {/* Contact form */}
      <NeedHelpContactForm
        prefillData={{
          ...userDataAtom,
          contactEmail: userDataAtom?.email,
        }}
        onSubmit={handleSubmit}
      />
    </div>
    </div>
  );
};

export default CustomerNeedHelpContact;
